<template>
  <span>
    <a @click="showModal" :class="'btn btn-sm btn-secondary' + (adjusterIds.length ? '' : ' disabled')">
      <i class="fa fa-fw fa-send"></i> Send Message
    </a>

    <modal :id="modalId">

      <template v-slot:header>
        <h4 class="modal-title">Send Message To Adjuster{{ adjusterIds.length > 1 ? 's' : '' }}</h4>
      </template>

      <div class="text-danger text-center">
        <strong>
          Are you sure you want to send message to <strong>{{ adjusterIds.length }}</strong>
          selected adjuster{{ adjusterIds.length > 1 ? 's' : '' }}?
        </strong>
      </div>

      <div class="form-group row my-3">
        <label for="text" class="col-form-label col-sm-2">Text:</label>
        <div class="col-sm-10">
          <textarea v-model="text" class="form-control form-control-sm" cols="50" rows="10" placeholder="Enter a text to send out to adjusters"></textarea>

          <div class="row">
            <div class="col-md-6">
              <div v-if="!text" class="text-danger">Text is required.</div>
            </div>

            <div class="col-md-6 text-right">
              <button v-if="initialText" @click="text = initialText" class="btn btn-xs btn-default">
                Load initial text campaign text <i class="fa fa-arrow-up"></i>
              </button>
            </div>
          </div>
        </div>
      </div>

      <template v-slot:footer>
        <button type="button" class="btn btn-white" @click="hideModal"><i class="fa fa-fw fa-ban"></i> Close</button>

        <form method="POST" :action="action">
          <input type="hidden" name="_token" :value="$csrf_token">
          <input type="hidden" name="text" :value="text">
          <input type="hidden" name="adjuster_ids" :value="adjusterIds">
          <button type="submit" class="btn btn-danger" :disabled="!text"><i class="fa fa-fw fa-send"></i> Send Message</button>
        </form>
      </template>

    </modal>
  </span>
</template>

<script>
import HasModal from "./../mixins/HasModal";
import { mapState } from 'pinia'
import { useTextCampaignAdjusterDataStore } from '../../stores/textCampaignAdjusterData'

export default {
  mixins: [HasModal],

  props: {

    // Modal dialog id.
    modalId: {
      type: String,
      default: 'textCampaignSendMessageModal'
    },

    // Form action value.
    action: {
      type: String,
      required: true
    },

    // Initial text campaign text.
    initialText: {
      type: String,
      default: ''
    },

  },

  /**
   * Variables (models).
   */
  data() {
    return {
      text: '',
    }
  },

  /**
   * Computed values
   */
  computed: {
    ...mapState(useTextCampaignAdjusterDataStore, {adjusterIds: 'selectedAdjusterIds'}),
  },
}
</script>
